import { render, staticRenderFns } from "./repair-create-before-picture.vue?vue&type=template&id=0dad4430"
import script from "./repair-create-before-picture.vue?vue&type=script&lang=js"
export * from "./repair-create-before-picture.vue?vue&type=script&lang=js"
import style0 from "./repair-create-before-picture.vue?vue&type=style&index=0&id=0dad4430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports